// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","wrapper":"_3cPtvbOC8HU4yaUT5e4-am","container":"jK8UKHcDK2kTxwwVmT64r","cardsContainer":"_1_cES44ukV9p-KuhBqezxK","featuresTable":"aajfr_fIFA4TiYnI-RTYk"};